import {renderStructuredElements} from "@/utils/render-helpers.jsx";
import FullScreenOverlay from "@/components/FullScreenOverlay";
document.addEventListener("DOMContentLoaded", () => {
  renderStructuredElements("full-screen-overlay", FullScreenOverlay);
});
